// extracted by mini-css-extract-plugin
module.exports = {"vehicleButton":"styles_vehicleButton__3wNln","blueBtn":"styles_blueBtn__2OzC2","vehicleButtonBoi":"styles_vehicleButtonBoi__1HLic","blueBtnBoi":"styles_blueBtnBoi__6-Gug"};